import * as React from 'react';
import { Button } from 'reactstrap';

interface IProjectPropositionCardActions {
  status: string;
  handlePropositionChange: (action: string) => void;
}

export const ProjectPropositionCardActions: React.SFC<
  IProjectPropositionCardActions
> = ({ status, handlePropositionChange }) =>
  status === 'validated' ? (
    <>
      <Button
        className='text-uppercase text-white bg-success border-0 m-2'
        onClick={() => handlePropositionChange('shortlist')}
      >
        Shortlist
      </Button>
      <Button
        className='text-uppercase text-white bg-dark border-0 m-2'
        style={{ opacity: 0.5 }}
        onClick={() => handlePropositionChange('reject')}
      >
        Décliner
      </Button>
    </>
  ) : status === 'shortlisted' ? (
    <>
      <Button
        className='text-uppercase text-white bg-warning border-0 m-2'
        onClick={() => handlePropositionChange('accept')}
      >
        On y va !
      </Button>
      <Button
        className='text-uppercase text-white bg-dark border-0 m-2'
        style={{ opacity: 0.5 }}
        onClick={() => handlePropositionChange('reject') }
      >
        Décliner
      </Button>
    </>
  ) : null;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositionCard/ProjectPropositionCardActions.tsx